import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { BusinessDtoKeysEnum } from '@zaoblako/shared/modules/business/enum/business-dto-keys.enum';
import type { ThreadFindInterface } from '@zaoblako/shared/modules/messenger/dtos/thread/thread-find.dto';
import { type DocumentsStatisticsFindInterface, DocumentsStatisticsFindDto } from '@zaoblako/shared/modules/business/dto/documents-statistics-find.dto';
import type { DealFindInterface } from '@zaoblako/shared/modules/business/dto/deal/deal-find.dto';
import { type UserGroupFindInterface, UserGroupFindDto } from '@zaoblako/shared/modules/security/dtos/user-group/user-group-find.dto';
import { type UserFindInterface, UserFindDto } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { MessengerDtoKeysEnum } from '@zaoblako/shared/modules/messenger/enums/messenger-dto-keys.enum';

import * as yup from 'yup';

export interface DealsGroupFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Group creation date and time */
  created: Date;
  /** Group last update date and time */
  updated: Date;
  /** Group deletion date and time */
  deleted: Date;
  /** Group display name */
  name: string;
  /** Group creator */
  createdBy: UserFindInterface;
  /** User auditors (deals group participants) */
  userAuditors: UserFindInterface[];
  /** Group auditors (deals group participants) */
  groupAuditors: UserGroupFindInterface[];
  /** Deals included in this group */
  deals: DealFindInterface[];
  /** Documents statistics for this deals group */
  documentStatistics: DocumentsStatisticsFindInterface;
  thread?: ThreadFindInterface;
}

export const DealsGroupFindDto = SerdeDtoClass.create<DealsGroupFindInterface>(BusinessDtoKeysEnum.DEAL_GROUP_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    label: 'Обновлён',
    serializer: yup.date(),
  },
  deleted: {
    label: 'Удалён',
    serializer: yup.date(),
  },
  name: {
    label: 'Имя',
    serializer: yup.string(),
  },
  createdBy: {
    label: 'Создатель',
    nested: UserFindDto,
    serializer: (_, nested) => nested,
  },
  userAuditors: {
    label: 'Аудиторы',
    nested: UserFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
  groupAuditors: {
    label: 'Группы аудиторов',
    nested: UserGroupFindDto,
    serializer: (_, nested) => yup.array(nested),
  },
  deals: {
    label: 'Сделки',
    nested: BusinessDtoKeysEnum.DEAL_FIND_DTO,
    serializer: (_, nested) => yup.array(nested),
  },
  documentStatistics: {
    label: 'Статистика документов',
    nested: DocumentsStatisticsFindDto,
    serializer: (_, nested) => nested,
  },
  thread: {
    optional: true,
    label: 'thread',
    nested: MessengerDtoKeysEnum.THREAD_FIND_DTO,
    serializer: (_, nested) => nested,
  },
});
